/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { SubmissionResponseDto } from './SubmissionResponseDto';
import {
    SubmissionResponseDtoFromJSON,
    SubmissionResponseDtoFromJSONTyped,
    SubmissionResponseDtoToJSON,
    SubmissionResponseDtoToJSONTyped,
} from './SubmissionResponseDto';

/**
 * 
 * @export
 * @interface SubmissionPaginationResponseDto
 */
export interface SubmissionPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof SubmissionPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<SubmissionResponseDto>}
     * @memberof SubmissionPaginationResponseDto
     */
    items: Array<SubmissionResponseDto>;
}

/**
 * Check if a given object implements the SubmissionPaginationResponseDto interface.
 */
export function instanceOfSubmissionPaginationResponseDto(value: object): value is SubmissionPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SubmissionPaginationResponseDtoFromJSON(json: any): SubmissionPaginationResponseDto {
    return SubmissionPaginationResponseDtoFromJSONTyped(json, false);
}

export function SubmissionPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(SubmissionResponseDtoFromJSON)),
    };
}

export function SubmissionPaginationResponseDtoToJSON(json: any): SubmissionPaginationResponseDto {
    return SubmissionPaginationResponseDtoToJSONTyped(json, false);
}

export function SubmissionPaginationResponseDtoToJSONTyped(value?: SubmissionPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(SubmissionResponseDtoToJSON)),
    };
}

